import { MetricLocalizationSliceType } from "@/types";

export const initialState: MetricLocalizationSliceType = {
    metricLocalization: null,
};